import axios from "axios"
import { imvs_url } from "./host_data"

export default async function EditImv({ nreg, fieldData }) {
    try {
        console.log('Imovel antes do envio de edição: ', fieldData)
        const response = await axios.put(`${imvs_url}${nreg}/`, fieldData, {
            headers: {
                'api-key': 'xUp2jAz5hQZM#wCsKb',
                'Content-Type': 'application/json'
            },
        })

        return response
    } catch (e) {
        console.log('Erro ao Editar Imovel: ', e)
    }

}